module.exports = __webpack_public_path__ + "static/media/info-kn.90e6f500.svg";